<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <v-col cols="12">
        <filtro-component
          :opcoes="opcoes"
          :modos="modos"
          :tipos="tipos"
          :calendar="'mes'"
          :produtos="tipos_funerarios"
          @filtrar="filterData"
          :title_opcao="'Situação'"
        ></filtro-component>
      </v-col>
    </v-container>

    <v-container
      style="background-color: #eee"
      id="contrato"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">

          <!-- Checkboxes para Baixa -->
          <v-col cols="12" v-if="selectedType === 'Baixa'">
            <v-card outlined class="pa-3">
              <v-card-title class="text-h6">Adicionar na Baixa</v-card-title>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-checkbox
                    v-model="mongeral"
                    label="Mongeral"
                    color="primary"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-checkbox
                    v-model="cancelamento"
                    label="Cancelamento"
                    color="primary"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Tabela para Consulta de Baixas -->
          <base-material-card
            v-if="selectedType === 'Consulta de Baixas'"
            icon="mdi-file-document-refresh-outline"
            title="Consulta de Baixas"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="consultaBaixas_header"
              :items="consultaBaixas"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:item="row">
                <tr :class="{ 'gray-row': row.index % 2 !== 0 }">
                  <td style="width: 18%; font-size: 14px">
                    <div>{{ row.item.baixa?.numero || "" }}</div>
                    <div style="margin-top: 8px; font-weight: bold;" :style="{ color: getStatusColor(row.item) }">
                      STATUS: {{ getStatusDisplay(row.item) || row.item.baixa?.statusImportacao || "N/A" }}
                    </div>
                    <div style="margin-top: 4px; color: #666;">
                      OBSERVAÇÃO: {{ row.item.baixa?.observacao || "" }}
                    </div>
                  </td>
                  <td style="width: 12%; font-size: 14px">
                    {{
                      parseFloat(row.item.baixa?.valorBaixaLiquida || 0).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td style="width: 12%; font-size: 14px">
                    {{
                      parseFloat((row.item.baixa?.valorMulta || 0) + (row.item.baixa?.valorJuros || 0)).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td style="width: 12%; font-size: 14px">
                    {{
                      parseFloat(row.item.baixa?.valorDesconto || 0).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td style="width: 12%; font-size: 14px">
                    {{ row.item.descricaoFormaPagamento || "" }}
                  </td>
                  <td style="width: 12%; font-size: 14px">
                    {{ formatDateBr(row.item.baixa?.dataEnvio) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            
            <!-- Resumo de Totais -->
            <v-card outlined class="mt-4">
              <v-card-title class="text-h4 pa-6" style="background-color: #f5f5f5;">
                Resumo de Totais
              </v-card-title>
              <v-card-text class="pa-3">
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Baixa Líquida</div>
                    <div class="text-h6 font-weight-bold" style="color: #1976d2;">
                      {{ totalBaixaLiquida }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Multa e Juros</div>
                    <div class="text-h6 font-weight-bold" style="color: #f57c00;">
                      {{ totalMultaJuros }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Desconto</div>
                    <div class="text-h6 font-weight-bold" style="color: #388e3c;">
                      {{ totalDesconto }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Geral</div>
                    <div class="text-h4 font-weight-bold" style="color: #d32f2f; text-shadow: 1px 1px 2px rgba(0,0,0,0.1);">
                      {{ totalGeral }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <div class="text-body-2 mb-6" style="color: #424242;">
                  Informações de Baixas
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Caixa</div>
                    <div class="text-h6 font-weight-bold" style="color: #1976d2;">
                      {{ totalCaixa }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total Boleto</div>
                    <div class="text-h6 font-weight-bold" style="color: #f57c00;">
                      {{ totalBoleto }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Total com ERRO</div>
                    <div class="text-h6 font-weight-bold" style="color: #d32f2f;">
                      {{ totalErro }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div class="text-caption text--secondary">Qtd de Documentos</div>
                    <div class="text-h6 font-weight-bold" style="color: #388e3c;">
                      {{ quantidadeDocumentos }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <div class="text-caption text--secondary">Total de Baixas no Ivertex</div>
                    <div class="text-h6 font-weight-bold" style="color: #7b1fa2;">
                      {{ formatCurrency(totalBaixasIvertex) }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <div class="text-caption text--secondary">Diferença (Total Geral - Total de Baixas no Ivertex)</div>
                    <div class="text-h6 font-weight-bold" style="color: #1976d2;">
                      {{ diferencaTotalIvertex }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-btn
                      color="primary"
                      large
                      @click="importarBaixaPeriodo"
                      :loading="loadingImportacao"
                      :disabled="!selectedCompanies || selectedCompanies.length === 0 || selectedCompanies.includes('Todas')"
                    >
                      <v-icon left>mdi-upload</v-icon>
                      Importar Baixa do Periodo
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <br />
          </base-material-card>

          <!-- Tabela padrão para Interações -->
          <base-material-card
            v-if="selectedType === 'Interações'"
            icon="mdi-file-document-refresh-outline"
            title="Interações de Baixas"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="documentos_header"
              :items="documentos"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:item="row">
                <tr :class="{ 'gray-row': row.index % 2 !== 0 }">
                  <td style="width: 15%; font-size: 14px">
                    {{ formatDateHoraBr(row.item.dataConsulta) }}
                  </td>

                 
                  <td style="width: 10%; font-size: 14px">
                    {{ row.item.tipo }}
                  </td>
                  <td style="width: 10%; font-size: 14px">
                    {{ formartPeriodo(row.item.periodo) }}
                  </td>
                  <td style="width: 10%; font-size: 14px">
                    {{ row.item.situacao }}
                  </td>
                  <td style="width: 10%; font-size: 14px">
                    <v-chip
                      :color="getEmpresa(row.item.empresa)"
                      text-color="white"
                    >
                      {{ row.item.empresa }}
                    </v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <br />
          </base-material-card>
          <br />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Radar from "../../services/radar";
import { ContentLoader } from "vue-content-loader";
import FiltroComponent from "./components/FiltroDuo.vue"; // Certifique-se de que o caminho esteja correto

export default {
  name: "Cobranca",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
  },

  mounted() {
    this.selectedStartDate = this.getFirstDayOfMonth();
    this.selectedEndDate = this.formatDateBR(new Date());
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || "Obrigatório.",
      },

      empresa: "Todas",
      search: "",
      selectedCompany: "Todas",
      selectedCompanies: [],
      selectedType: "Todos",
      selectedOpcao: "Todas",
      selectedOpcao2: "NEGATIVADO",
      documento: 0,
      selectMode: "Todos",
      produto: "Todos",
      mongeral: false,
      cancelamento: false,
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      opcoes: [],
      modos: ["Data"],
      showFilter: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Interações", "Consulta de Baixas"],

      showProgress: false,
      currentGroup: null,
      dias: 1,
      tipos_funerarios: ["Todos"],

      documentos: [],
      documentos_header: [
        { text: "Data", value: "data" },
        { text: "Tipo", value: "tipo" },
        { text: "Periodo", value: "periodo" },
        { text: "Situação", value: "situação" },
        { text: "Empresa", value: "empresa" },
      ],
      consultaBaixas: [],
      totalBaixasIvertex: 0,
      loadingImportacao: false,
      consultaBaixas_header: [
        { text: "DOCUMENTO", value: "numero" },
        { text: "BAIXA", value: "valorBaixaLiquida" },
        { text: "MULTA E JUROS", value: "multaJuros" },
        { text: "DESCONTO", value: "valorDesconto" },
        { text: "FORMA DE PAGAMENTO", value: "descricaoFormaPagamento" },
        { text: "DATA IMPORTACAO", value: "dataEnvio" },
      ],
    };
  },

  watch: {
    // Observa mudanças no selectedType para mostrar checkboxes imediatamente
    selectedType(newValue) {},
  },

  computed: {
    // Calcula o total de Baixa Líquida
    totalBaixaLiquida() {
      const total = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorBaixaLiquida || 0);
      }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o total de Multa e Juros
    totalMultaJuros() {
      const total = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorMulta || 0) + parseFloat(item.baixa?.valorJuros || 0);
      }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o total de Desconto
    totalDesconto() {
      const total = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorDesconto || 0);
      }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o Total Geral (Baixa Líquida + Multa e Juros - Desconto)
    totalGeral() {
      const totalBaixa = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorBaixaLiquida || 0);
      }, 0);
      const totalMultaJuros = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorMulta || 0) + parseFloat(item.baixa?.valorJuros || 0);
      }, 0);
      const totalDesconto = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorDesconto || 0);
      }, 0);
      const total = totalBaixa + totalMultaJuros - totalDesconto;
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o Total de Caixa (soma de Baixa Líquida + Multa e Juros - Desconto onde forma de pagamento é Caixa)
    totalCaixa() {
      const total = this.consultaBaixas
        .filter(item => item.descricaoFormaPagamento === "Caixa")
        .reduce((sum, item) => {
          const baixa = item.baixa?.valorBaixaLiquida || 0;
          const multaJuros = (item.baixa?.valorMulta || 0) + (item.baixa?.valorJuros || 0);
          const desconto = item.baixa?.valorDesconto || 0;
          return sum + parseFloat(baixa) + parseFloat(multaJuros) - parseFloat(desconto);
        }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o Total de Boleto (soma de Baixa Líquida + Multa e Juros - Desconto onde forma de pagamento é Boleto)
    totalBoleto() {
      const total = this.consultaBaixas
        .filter(item => item.descricaoFormaPagamento === "Boleto")
        .reduce((sum, item) => {
          const baixa = item.baixa?.valorBaixaLiquida || 0;
          const multaJuros = (item.baixa?.valorMulta || 0) + (item.baixa?.valorJuros || 0);
          const desconto = item.baixa?.valorDesconto || 0;
          return sum + parseFloat(baixa) + parseFloat(multaJuros) - parseFloat(desconto);
        }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o Total com ERRO (soma de Baixa Líquida + Multa e Juros - Desconto onde statusImportacao é ERRO e observacao diferente de "O título informado já está baixado")
    totalErro() {
      const total = this.consultaBaixas
        .filter(item => {
          const baixa = item.baixa;
          if (!baixa) return false;
          
          const status = baixa.statusImportacao;
          const observacao = baixa.observacao || "";
          
          // Filtra apenas ERRO que NÃO tenha a observação específica
          return status === "ERRO" && 
                 !observacao.includes("O título informado já está baixado");
        })
        .reduce((sum, item) => {
          const baixa = item.baixa?.valorBaixaLiquida || 0;
          const multaJuros = (item.baixa?.valorMulta || 0) + (item.baixa?.valorJuros || 0);
          const desconto = item.baixa?.valorDesconto || 0;
          return sum + parseFloat(baixa) + parseFloat(multaJuros) - parseFloat(desconto);
        }, 0);
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    // Calcula o valor numérico do Total Geral (sem formatação)
    totalGeralNumerico() {
      const totalBaixa = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorBaixaLiquida || 0);
      }, 0);
      const totalMultaJuros = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorMulta || 0) + parseFloat(item.baixa?.valorJuros || 0);
      }, 0);
      const totalDesconto = this.consultaBaixas.reduce((sum, item) => {
        return sum + parseFloat(item.baixa?.valorDesconto || 0);
      }, 0);
      return totalBaixa + totalMultaJuros - totalDesconto;
    },
    // Calcula a diferença entre Total Geral e Total de Baixas no Ivertex
    diferencaTotalIvertex() {
      const diferenca = this.totalGeralNumerico - this.totalBaixasIvertex;
      return this.formatCurrency(diferenca);
    },
    // Calcula a quantidade de documentos na tabela
    quantidadeDocumentos() {
      return this.consultaBaixas.length;
    },
    // Retorna a quantidade de documentos na tabela
    quantidadeDocumentos() {
      return this.consultaBaixas.length || 0;
    },
  },

  methods: {
    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatDateBr(dateString) {
      if (!dateString) return "";
      try {
        // Formata data ISO para formato BR (dd/mm/yyyy)
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          // Se não conseguir parsear, tenta extrair apenas a data da string ISO
          const datePart = dateString.split('T')[0];
          if (datePart) {
            const [year, month, day] = datePart.split('-');
            return `${day}/${month}/${year}`;
          }
          return dateString;
        }
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return dateString;
      }
    },
    formatCurrency(value) {
      const numValue = parseFloat(value) || 0;
      return numValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formartPeriodo(periodo) {
      if(periodo === "") return "";
      // Divide as duas datas pelo " - "
      const [inicio, fim] = periodo.split(" - ").map((d) => d.trim());

      // Função auxiliar para formatar uma data (evita problema de timezone)
      const formatDate = (dateStr) => {
        // Parse manual para evitar problemas de timezone
        const [year, month, day] = dateStr.split("-");
        return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
      };

      // Retorna as duas formatadas
      return `${formatDate(inicio)} - ${formatDate(fim)}`;
    },
    formatDateHoraBr(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      const hours = String(parsedDate.getHours()).padStart(2, "0");
      const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    filterData(valores) {
      this.isLoading = true;
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      // Armazena o array completo de empresas selecionadas
      this.selectedCompanies = valores.selectedCompany.filter(emp => emp !== "" && emp !== "Todas");
      // Pega a primeira empresa não vazia do array (sem vírgulas) para compatibilidade
      this.selectedCompany = valores.selectedCompany.find(emp => emp !== "" && emp !== "Todas") || "";
      this.selectedType = valores.selectedType;

      // Limpar consultaBaixas se não for o tipo "Consulta de Baixas"
      if (this.selectedType !== "Consulta de Baixas") {
        this.consultaBaixas = [];
      }

      // Debug para verificar o valor
      console.log("Tipo selecionado:", this.selectedType);
      console.log("Empresa selecionada:", this.selectedCompany);
      console.log("Empresas selecionadas:", this.selectedCompanies);

      this.dashboard();
    },

    getEmpresa(status) {
      switch (status) {
        case "Parque":
          return "orange darken-2";
        case "Versan":
          return "blue lighten-1";
        case "Memorial":
          return "green lighten-1";
        case "Am":
          return "cyan lighten-1";
        case "Previda":
          return "blue lighten-1";
        case "A FLOR DO CAFÉ":
          return "purple lighten-1";

        default:
          return "success";
      }
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    getHistorico(dataInicial, dataFinal, empresa) {
      Radar.historicoapp(dataInicial, dataFinal, empresa)
        .then((response) => {
          if (response.status === 200) {
            this.documentos = response.data || [];
          }
        })
        .catch((e) => {
          console.error("Erro ao buscar histórico:", e);
          this.documentos = [];
        })
        .finally(() => {});
    },

    getStatus(status) {
      switch (status) {
        case "Ativo":
          return "blue lighten-1";
        case "Cancelado":
          return "red lighten-1";
        default:
          return "success";
      }
    },
    // Retorna o status a ser exibido (AVISO se for ERRO com observação específica)
    getStatusDisplay(item) {
      if (!item) return "N/A";
      const baixa = item.baixa || item;
      if (!baixa) return "N/A";
      
      const status = baixa.statusImportacao;
      const observacao = baixa.observacao;
      
      // Se for ERRO com observação específica, retorna AVISO
      if (
        status === "ERRO" &&
        observacao &&
        typeof observacao === "string" &&
        observacao.includes("O título informado já está baixado")
      ) {
        return "AVISO";
      }
      
      // Retorna o status original ou "N/A" se não existir
      return status || "N/A";
    },
    // Retorna a cor do status (amarelo para AVISO, vermelho para ERRO)
    getStatusColor(item) {
      if (!item) return "#d32f2f";
      const baixa = item.baixa || item;
      if (!baixa) return "#d32f2f";
      
      const status = baixa.statusImportacao;
      const observacao = baixa.observacao;
      
      // Se for ERRO com observação específica, retorna amarelo
      if (
        status === "ERRO" &&
        observacao &&
        typeof observacao === "string" &&
        observacao.includes("O título informado já está baixado")
      ) {
        return "#f57c00"; // Amarelo/laranja
      }
      
      // Retorna vermelho para ERRO ou outras cores conforme necessário
      if (status === "ERRO") {
        return "#d32f2f"; // Vermelho para ERRO
      }
      
      // Cor padrão para outros status
      return "#666"; // Cinza para outros casos
    },

    dashboard() {
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 31) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 31;
        return;
      }

      if (this.selectedType == "Consulta de Baixas") {
        // Regra 1: Validar que apenas 1 empresa foi selecionada
        if (!this.selectedCompanies || this.selectedCompanies.length === 0) {
          this.isLoading = false;
          alert("Por favor, selecione exatamente uma empresa.");
          return;
        }
        if (this.selectedCompanies.length > 1) {
          this.isLoading = false;
          alert("Por favor, selecione apenas uma empresa.");
          return;
        }
        if (this.selectedCompanies.includes("Todas")) {
          this.isLoading = false;
          alert("Por favor, selecione uma empresa específica (não 'Todas').");
          return;
        }

        // Regra 2: Validar que data inicial e final são iguais
        if (formattedStartDate !== formattedEndDate) {
          this.isLoading = false;
          alert("A data inicial e a data final devem ser iguais.");
          return;
        }

        // Chamar as APIs em paralelo
        Promise.all([
          Radar.consultarBaixasPorDataEEmpresa(
            formattedStartDate,
            this.selectedCompanies[0]
          ),
          Radar.totalBaixaTitulosIvertex(
            formattedStartDate,
            formattedEndDate,
            this.selectedCompanies[0]
          )
        ])
          .then(([baixasResponse, ivertexResponse]) => {
            // Processar resposta de baixas
            if (baixasResponse.status === 200) {
              if (baixasResponse.data && Array.isArray(baixasResponse.data)) {
                this.consultaBaixas = baixasResponse.data;
              } else if (baixasResponse.data && !Array.isArray(baixasResponse.data)) {
                this.consultaBaixas = [];
                alert(baixasResponse.data || "Consulta realizada com sucesso.");
              } else {
                this.consultaBaixas = [];
                alert("Nenhum resultado encontrado.");
              }
            }

            // Processar resposta do Ivertex
            if (ivertexResponse.status === 200) {
              // O retorno é um objeto com mensagem2 contendo o valor
              const valor = ivertexResponse.data?.mensagem2 || ivertexResponse.data || 0;
              const total = parseFloat(valor) || 0;
              this.totalBaixasIvertex = total;
            }
          })
          .catch((e) => {
            console.error("Erro ao consultar:", e);
            this.consultaBaixas = [];
            this.totalBaixasIvertex = 0;
            alert("Erro ao consultar: " + (e.response?.data?.message || e.message));
          })
          .finally(() => {
            this.isLoading = false;
          });
        return;
      }

      if (this.selectedCompany === "Todas") return;

      if (this.selectedType == "Interações") {
        // Para Interações, carrega o histórico com os parâmetros do filtro
        const empresa = this.selectedCompany && this.selectedCompany !== "Todas" ? this.selectedCompany : null;
        this.getHistorico(formattedStartDate, formattedEndDate, empresa);
        this.isLoading = false;
        return;
      }

      if (this.selectedType == "Lançamento") {
        Radar.lancamento(
          formattedStartDate,
          formattedEndDate,
          this.selectedCompany,
          this.documento
        )
          .then((response) => {
            if (response.status === 200) {
              alert(response.data);
            }
          })
          .catch((e) => {})
          .finally(() => {});
      } else if (this.selectedType == "Baixa") {
        const mongeralValue = this.mongeral ? "1" : "0";
        const cancelamentoValue = this.cancelamento ? "1" : "0";

        Radar.baixa(
          formattedStartDate,
          formattedEndDate,
          this.selectedCompany,
          this.documento,
          mongeralValue,
          cancelamentoValue
        )
          .then((response) => {
            if (response.status === 200) {
              alert(response.data);
            }
          })
          .catch((e) => {})
          .finally(() => {});
      } else if (this.selectedType == "Analise") {
        Radar.verifica(
          formattedStartDate,
          formattedEndDate,
          this.selectedCompany
        )
          .then((response) => {
            if (response.status === 200) {
              alert(response.data);
            }
          })
          .catch((e) => {})
          .finally(() => {});
      } else alert("Escolha opção diferente" + this.selectedType);
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    // Importar Baixa do Periodo
    importarBaixaPeriodo() {
      // Validar que uma empresa foi selecionada
      if (!this.selectedCompanies || this.selectedCompanies.length === 0 || this.selectedCompanies.includes("Todas")) {
        alert("Por favor, selecione uma empresa específica.");
        return;
      }

      // Confirmar ação
      if (!confirm("Deseja realmente importar a baixa do período? Este processo pode levar mais de 1 hora para ser concluído.")) {
        return;
      }

      this.loadingImportacao = true;

      const formattedStartDate = converteDataParaFormatoISO(this.selectedStartDate);
      const empresa = this.selectedCompanies[0];

      Radar.executarLancamentoTitulosPorRecebimentoData(formattedStartDate, empresa)
        .then((response) => {
          if (response.status === 200) {
            alert(response.data || "Processamento iniciado com sucesso!");
          }
        })
        .catch((e) => {
          console.error("Erro ao importar baixa:", e);
          alert("Erro ao importar baixa: " + (e.response?.data?.message || e.message));
        })
        .finally(() => {
          this.loadingImportacao = false;
        });
    },
  },
};

function converteDataParaFormatoISO(dataNoFormatoBR) {
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 80px;
}

.vuetify__expand-icon {
  display: none !important; /* Oculta os ícones de expandir */
}
/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.card-loader {
  height: 100%; /* Define a altura do content-loader como 100% para preencher o v-card */
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-data-table-header-mobile .v-data-table-header-group {
  display: none !important; /* Oculta os botões de expansão de grupo */
}
</style>
